<template>
  <v-card style="margin-bottom:1em" class="RelatorioExportacoesUsuarioFiltros">
    <v-form ref="form" autocomplete="off">
      <v-card-title>
        <div class="title">{{ $tc('title.usuario', 2) }}</div>
        <v-spacer></v-spacer>
        <v-icon v-show="mostrarFiltros"
          @click="fixaFiltros"
          :class="filtrosFixosClass"
          style="margin-right: 10px"
          >fa-thumbtack</v-icon>
        <v-icon @click="toggleMostrarFiltros">filter_list</v-icon>
      </v-card-title>
      <v-container fluid grid-list-md v-show="mostrarFiltros">
        <metadados-container-layout
          :ordenacao-campos="ordenacaoCampos"
          :campos-formulario="camposFormulario"
          :explode-hierarquia="true"
          :formulario-filtros="true"
          :ignora-inativos="false"
          :ignora-obrigatorios="umFiltroObrigatorioSelecionado"
          :objeto="filtrosExportacaoUsuario"
          ref="container">
        </metadados-container-layout>
      </v-container>
      <v-card-actions v-show="mostrarFiltros">
        <v-spacer></v-spacer>
        <v-btn @click="resetaFiltros"
          color="accent"
        >{{$t('label.limpar_filtros')}}</v-btn>
        <v-btn @click="aplicarFiltros"
          color="primary"
        >{{$t('label.exportar')}}</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>
<script>
import { skipLoading } from '@/common/functions/loading';
import { countRelatorioUsuario } from '@/common/resources/magalu-relatorios'; // eslint-disable-line
import MetadadosContainerLayout from '@/shared-components/metadados/MetadadosContainerLayout';
import RelatorioExportacaoUsuarioFiltrosCampos from './RelatorioExportacaoUsuarioFiltrosCampos';

export default {
  name: 'RelatorioExportacaoUsuario',
  mixins: [
    RelatorioExportacaoUsuarioFiltrosCampos,
  ],
  computed: {
    filtrosFixosClass() {
      return {
        'primary--text': this.filtrosFixados,
        'mr-2': true,
      };
    },
  },
  components: {
    MetadadosContainerLayout,
  },
  data() {
    return {
      ordenacaoCampos: [
        'tipo_usuario',
        'fornecedor',
        'perfil',
        'status_aprovacao',
        'ativo',
      ],
      mostrarFiltros: false,
      filtrosFixados: false,
      filtrosExportacaoUsuario: {},
      umFiltroObrigatorioSelecionado: false,
      limiteRegistrosExportacao: 50000,
    };
  },
  methods: {
    toggleMostrarFiltros() {
      this.mostrarFiltros = !this.mostrarFiltros;
    },
    resetaFiltros() {
      this.filtrosExportacaoUsuario = {};
    },
    aplicarFiltros() {
      if (!this.$refs.form.validate()) {
        return;
      }
      const params = {
        ...this.$refs.container.getValoresCamposPadrao(),
        count: true,
      };

      let quantidadeRegistros = 0;

      countRelatorioUsuario(params, this.$resource)
        .then((response) => {
          quantidadeRegistros = response.data;
          if (quantidadeRegistros > this.limiteRegistrosExportacao) {
            this.$toast(this.$t('errors.registros.excede_limite_dados', { limite: this.limiteRegistrosExportacao }));
          } else if (quantidadeRegistros > 0) {
            delete params.count;
            this.$emit('RelatorioExportacaoUsuario__AplicaFiltros',
              params,
              'usuario_magalu',
              'api');
          } else {
            this.$toast(this.$t('errors.registros.nao_ha_dados'));
          }
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    fixaFiltros() {
      this.filtrosFixados = !this.filtrosFixados;
      this.workspace.indAberto = this.filtrosFixados;
      if (!this.workspace.id) {
        this.inserirWorkspace();
      } else {
        this.atualizarWorkspace();
      }
    },
    inserirWorkspace() {
      skipLoading();
      const entidade = 'relatorio-usuario';
      this.workspaceFiltrosResources.inserir({ entidade }, this.workspace)
        .then((response) => {
          this.workspace.id = response.data;
        }).catch((err) => {
          this.$error(this, err);
        });
    },
    atualizarWorkspace() {
      skipLoading();
      const entidade = 'relatorio-usuario';
      this.workspaceFiltrosResources.atualizar({ entidade }, this.workspace)
        .then()
        .catch((err) => {
          this.$error(this, err);
        });
    },
    salvarFiltrosWorkspace() {
      this.workspace.filtros = this.filtrosExportacaoUsuario;
      if (!this.workspace.id) {
        this.inserirWorkspace();
      } else {
        this.atualizarWorkspace();
      }
    },
  },
};
</script>
<style>
  .RelatorioExportacoesUsuarioFiltros__Opcoes {
    padding: 0 0 0 20px;
    margin-top: 0;
  }
  .RelatorioExportacoesUsuarioFiltros__Opcoes div.v-input__slot,
  .RelatorioExportacoesUsuarioFiltros__Opcoes div.v-radio {
    margin-bottom: 0;
  }
  .RelatorioExportacoesUsuarioFiltros__Opcoes div.v-messages {
    display: none;
  }
  .RelatorioExportacoesUsuarioFiltros__Opcoes label {
    font-size: 14px;
  }
</style>
